import * as XLSX from "xlsx/xlsx.mjs";
import { saveAs } from "file-saver";
import moment from "moment";

class Helpers {
  constructor() {
    this.BASE_URL = process.env.REACT_APP_BASE_URL;
  }

  waitTimeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  getCurrentDate() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  formatDateToInvoice(dt) {
    let dateString = dt.toLocaleString("en-GB", { timeZone: "Europe/Athens" }).split(",")[0];
    let dateSplitted = dateString.split("/");
    return `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}`;
  }

  formatDateToNormal(dt) {
    return moment(dt).format("DD/MM/YYYY HH:mm:ss");
  }

  downloadExcelFile(data, fileName) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  }
}
export default new Helpers();
